<template>
  <div class="app-container">
    <navigation title="问卷调查"></navigation>
    <div class="list">
      <van-cell is-link v-for="item in list" @click="go(item.id)" center>
        <template #title>
          <img v-if="item.iconPath" :src="baseUrl+item.iconPath" class="guide-list-icon">
          <span v-else></span>
          <span class="custom-title">{{ item.title }}</span>
        </template>
      </van-cell>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'questionList',
  components: {navigation, version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      list: [],
      checked: false,
      prompt: ''
    }
  },
  created () {
    // 列表
    this.getList()
  },
  methods: {
    getList () {
      var params = {
        pageNum: '1',
        pageSize: '10'
      }
      request('get', '/nlc-web/api/questionnaire/getName', params).then(res => {
        console.log('列表', res)
        this.list = res.data
      })
    },
    go (id) {
      this.$router.push(
        {
          path: `/question`,
          query: {
            id: id,
          }
        }
      )
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: calc(100% - 92px);
  position: absolute;
  top: 0px;
  bottom: 0px;
}

.list{
  width:6.94rem;
  background:#fff;
  margin:1.18rem .27rem 0 .29rem;
  border-radius:8px;
}
.van-cell{
  border-radius:8px;
}
.van-cell--clickable{
  height:1rem;
}
.wrapper{
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
}
.prompt{
  width: 4.9rem;
  background:#fff;
  font-size:.28rem;
  color:#47494c;
  border-radius:16px;
  padding:.34rem .3rem;
}
.prompt-title-tip{
  font-size:.36rem;
  /*color:#008095;*/
  position:relative;
  font-family: SourceHanSerifCN-SemiBold;
}
.prompt-message{
  width:96%;
  padding:0 2%;
  height:3rem;
  overflow-y:scroll;
  font-family: SourceHanSerifCN-Medium;
}
>>> .van-checkbox__label{
  line-height: .24rem;
  font-family: SourceHanSerifCN-Regular;
}
.close{
  position:absolute;
  right:.1rem;
  font-size:.36rem;
}
.isPrompt{
  width:72%;
  padding-left:28%;
  padding-top:.2rem;
}
.guide-list-icon{
  width:.28rem;
  height:.28rem;
  vertical-align: middle;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.custom-title{
  font-size:.28rem;
  font-family: SourceHanSerifCN-Medium;
}
</style>



// WEBPACK FOOTER //
// src/view/questionList/index.vue